// 国际化配置
export type Locale = 'en' | 'zh';

export const translations = {
  en: {
    // Header
    title: 'ALPHA ARENA：V1.8',
    nav: {
      live: 'LIVE',
      leaderboard: 'LEADERBOARD',
    },
    joinWaitlist: 'JOIN THE PLATFORM WAITLIST',
    connected: 'CONNECTED',

    // Account Value
    totalAccountValue: 'TOTAL ACCOUNT VALUE',
    timeRanges: {
      all: 'ALL',
      '72h': '72H',
      '24h': '24H',
      '12h': '12H',
      '5h': '5H',
    },
    liveTracking: 'Live account value tracking - Updates every 1 minute',

    // Tabs
    tabs: {
      completedTrades: 'COMPLETED TRADES',
      modelChat: 'MODEL CHAT',
      positions: 'POSITIONS',
      readme: 'README.TXT',
      leadingModels: 'LEADING MODELS',
    },

    // Completed Trades
    trades: {
      title: 'Recent Trades',
      count: 'trades',
      noTrades: 'No completed trades yet',
      aiWillStart: 'AI models will start trading soon',
      headers: {
        time: 'TIME',
        symbol: 'SYMBOL',
        side: 'SIDE',
        quantity: 'QUANTITY',
        price: 'PRICE',
        total: 'TOTAL',
        pnl: 'PNL',
        model: 'MODEL',
      },
      synced: 'Trade data synced from Hyperliquid - Updates in real-time',
    },

    // Positions
    positions: {
      title: 'Open Positions',
      activePositions: 'active positions',
      noPositions: 'No open positions',
      waitingForTrades: 'Waiting for AI models to open trades',
      totalPnl: 'Total Unrealized PnL',
      headers: {
        symbol: 'SYMBOL',
        side: 'SIDE',
        size: 'SIZE',
        entry: 'ENTRY',
        current: 'CURRENT',
        leverage: 'LEVERAGE',
        pnl: 'UNREALIZED PNL',
        liqPrice: 'LIQ. PRICE',
        model: 'MODEL',
      },
      updates: 'Positions update in real-time via Hyperliquid WebSocket',
    },

    // Model Chat
    chat: {
      greeting: '👋 Hello! I\'m your AI trading assistant. Ask me about my trading strategy, recent performance, or market analysis.',
      thinking: 'AI is thinking...',
      placeholder: 'Ask me anything about trading strategy...',
      send: 'Send',
      suggested: 'Suggested questions:',
      questions: [
        'What\'s your current strategy?',
        'Show me your recent trades',
        'What\'s your risk management approach?',
        'Analyze the BTC market',
      ],
      footer: 'AI responses are powered by Claude - Connect your API key to enable',
    },

    // Leading Models
    models: {
      title: 'Top Performing Models',
      ranked: 'Ranked by total ROI',
      active: 'active models',
      totalRoi: 'Total ROI',
      roi24h: '24h ROI',
      winRate: 'Win Rate',
      trades: 'Trades',
      sharpe: 'Sharpe',
      currentBalance: 'Current Balance',
      tracked: 'Model performance tracked in real-time - Data from Hyperliquid',
    },

    // README
    readme: {
      title: 'README.TXT',
      content: {
        heading: '# Alpha Arena - AI Trading Platform',
        description: 'This platform demonstrates autonomous AI trading agents operating on Hyperliquid DEX.',
        features: '## Features:',
        featureList: [
          'Real-time market data from Hyperliquid',
          'Autonomous AI trading models',
          'Live position tracking',
          'Trade history and analytics',
          'Model performance leaderboard',
        ],
        dataSources: '## Data Sources:',
        sourceList: [
          'Hyperliquid API (REST + WebSocket)',
          'Real-time price feeds',
          'On-chain trade execution',
        ],
        status: 'STATUS: All systems operational. AI models are actively trading.',
      },
    },

    // Leaderboard
    leaderboard: {
      title: 'Model Leaderboard',
      description: 'Coming soon - AI trading models ranked by performance',
    },

    // Status
    status: {
      streaming: 'STATUS: CONNECTED TO HYPERLIQUID',
      poweredBy: 'Real-time data powered by Hyperliquid API',
    },

    // Common
    common: {
      loading: 'Loading...',
      comingSoon: 'Coming soon...',
      buy: 'BUY',
      sell: 'SELL',
      long: 'LONG',
      short: 'SHORT',
      active: 'active',
      paused: 'paused',
      filter: 'FILTER',
      allModels: 'ALL MODELS',
      equity: 'Equity',
      roi: 'ROI',
      winRate: 'Win Rate',
      trades: 'Trades',
      netPnl: 'NET P&L',
      waitingForData: 'Waiting for data...',
      price: 'Price',
      quantity: 'Quantity',
      notional: 'Notional',
      holdingTime: 'Holding time',
      showingLast: 'Showing Last',
      tradesText: 'Trades',
      loadingPositions: 'Loading positions...',
      loadingTrades: 'Loading trades...',
      completedA: 'completed a',
      tradeOn: 'trade on',
      view: 'VIEW',
      availableCash: 'AVAILABLE CASH',
      side: 'SIDE',
      coin: 'COIN',
      leverage: 'LEVERAGE',
      exitPlan: 'EXIT PLAN',
      totalUnrealizedPnl: 'TOTAL UNREALIZED P&L',
    },

    // Control Panel
    control: {
      title: 'AI Trading Bot - Multi-Model Competition',
      competitionMode: 'Competition Mode: DeepSeek-V3, Doubao, Qwen and MACD Strategy will run simultaneously, trade independently, and compare performance in real-time!',
      deepseekTitle: 'DeepSeek-V3',
      doubaoTitle: 'Doubao',
      qwenTitle: 'Qwen',
      macdTitle: 'MACD Strategy',
      apiKey: 'API Key',
      apiKeyRequired: 'API Key *',
      modelEndpoint: 'Model Endpoint ID (Optional)',
      modelId: 'Model ID (Optional)',
      getApiKeys: 'Get your API keys from',
      volcengineConsole: 'Volcengine Ark Console',
      initialBalance: 'Initial Balance (USDT)',
      analysisInterval: 'Analysis Interval (minutes)',
      intervalOptions: {
        fast: '1 minute (Fast)',
        recommended: '5 minutes (Recommended)',
        conservative: '15 minutes (Conservative)',
        longTerm: '1 hour (Long-term)',
      },
      startBot: 'Start All Trading Bots',
      starting: 'Starting...',
      stopBot: 'Stop All Bots',
      stopping: 'Stopping...',
      botsRunning: 'Multi-Model Competition Running',
      analysisCount: 'Analysis #',
      latest: 'Latest:',
      performanceComparison: 'Performance Comparison',
      errorDeepseekKey: 'Please enter DeepSeek API Key',
      errorDoubaoKey: 'Please enter Doubao API Key',
      errorQwenKey: 'Please enter Qwen API Key',
      pnlLabel: 'PnL:',
      equityLabel: 'Equity:',
      macdStrategy: 'MACD Rule-Based Strategy',
      macdDescription: 'Fully automated rule-based trading without AI',
      aiStrategy: 'AI Model Strategy',
    },

    // Sidebar (old version, kept for compatibility)
    sidebar: {
      tabs: {
        completedTrades: 'COMPLETED TRADES',
        positions: 'POSITIONS',
        modelChat: 'MODELCHAT',
        readme: 'README.TXT',
      },
      readmeContent: {
        betterBenchmark: 'A Better Benchmark',
        description: 'Alpha Arena is the first benchmark designed to measure AI\'s trading abilities. Each model is given $1,000 of real money, in real markets, with identical prompts and input data.',
        goal: 'Our goal with Alpha Arena is to make benchmarks more like the real world, and markets are perfect for this. They\'re dynamic, adversarial, open-ended, and endlessly unpredictable. They challenge AI in ways that static benchmarks cannot.',
        ultimate: 'Markets are the ultimate test of intelligence.',
        question: 'So do we need to train models with new architectures for investing, or are LLMs good enough? Let\'s find out.',
        contestants: 'The Contestants',
        rules: 'Competition Rules',
        startingCapital: 'Starting Capital',
        startingCapitalDesc: 'each model gets $1,000 of real capital',
        market: 'Market',
        marketDesc: 'Crypto perpetuals on Hyperliquid',
        objective: 'Objective',
        objectiveDesc: 'Maximize risk-adjusted returns',
        transparency: 'Transparency',
        transparencyDesc: 'All model outputs and their corresponding trades and prices are public',
        autonomy: 'Autonomy',
        autonomyDesc: 'Each AI must produce alpha, size trades, and manage risk independently',
      },
    },

    // Trading Log
    tradingLog: {
      title: 'Trading Analysis',
      clickToExpand: 'Click to expand for detailed process',
      waitingForBot: 'Waiting for trading bot to start...',
      startMessage: 'Trading analysis will be displayed here once started',
      noRecords: 'No matching trading records',
      tryOtherFilters: 'Try switching to other filters',
      autoScroll: 'Auto scroll',
      pausedScroll: 'Paused',
      clearLogs: 'Clear logs',
      completeAnalysis: 'Complete Analysis Process',
      macdAnalysis: 'MACD Technical Analysis',
      extremumDetected: 'Extremum Point Detected',
      openSignal: 'Open Position Signal',
      closeSignal: 'Close Position Signal',
      emergencyClose: 'Emergency Close - Signal Prediction',
      dataCollection: 'Data Collection Phase',
      macdStrategy: 'MACD Rule-Based Strategy',
      aiStrategy: 'AI Model Strategy',
      marketData: 'Market Data Update',
      accountStatus: 'Account Status',
      riskCheck: 'Risk Check',
      execution: 'Trade Execution',
    },

    // Account Value
    accountValue: {
      totalValue: 'TOTAL ACCOUNT VALUE',
      waitingForData: 'Waiting for data...',
    },

    // Price Ticker
    priceTicker: {
      loading: 'Loading...',
    },

    // Page Buttons
    page: {
      models: 'MODELS',
      close: 'Close',
      control: 'Control',
    },

    // ETH Price & MACD
    ethPrice: {
      title: 'ETH PRICE & MACD',
      currentPrice: 'Current Price',
      change24h: '24H Change',
      open: 'Open',
      high: 'High',
      low: 'Low',
      close: 'Close',
      priceBox: 'Price Box',
      macdTitle: 'MACD Indicator',
      macdDif: 'DIF',
      macdDea: 'DEA',
      macdBar: 'MACD Bar',
      macdSignal: 'Signal',
      bullish: 'Bullish',
      bearish: 'Bearish',
      neutral: 'Neutral',
      clickTip: 'Click on DIF line to view slope details',
      firstOrderSlope: '1st Order Slope',
      secondOrderSlope: '2nd Order Slope',
      macdFirstOrderSlope: 'MACD 1st Order Slope',
      macdSecondOrderSlope: 'MACD 2nd Order Slope',
      slopeDirection: 'Slope Direction',
      trendStrength: 'Trend Strength',
      slopeSignal: 'Slope Signal',
      accelerating: 'Accelerating',
      decelerating: 'Decelerating',
      stable: 'Stable',
      strong: 'Strong',
      moderate: 'Moderate',
      weak: 'Weak',
      up: 'Up',
      down: 'Down',
      flat: 'Flat',
      // BOLL带
      bollBands: 'BOLL Bands (VWAP)',
      bollUpper: 'Upper Band',
      bollMiddle: 'Middle Band (VWAP)',
      bollLower: 'Lower Band',
      percentB: '%B Indicator',
      bandwidth: 'Bandwidth',
    },

    // MACD Strategy Rules
    macdRules: {
      title: 'MACD Rule-Based Strategy',
      subtitle: 'Automated trading based on technical indicators',
      strongUptrend: 'Strong Uptrend',
      strongUptrendDesc: 'DIF 1st slope > 0.3 AND 2nd slope > 0',
      strongUptrendAction: 'Open LONG / Hold LONG / Close SHORT',
      strongDowntrend: 'Strong Downtrend',
      strongDowntrendDesc: 'DIF 1st slope < -0.3 AND 2nd slope < 0',
      strongDowntrendAction: 'Open SHORT / Hold SHORT / Close LONG',
      stableTrend: 'Stable Trend',
      stableTrendDesc: 'DIF 1st slope between -0.3 and 0.3',
      stableTrendAction: 'Hold position, no new positions',
      weakUptrend: 'Weak Uptrend',
      weakUptrendDesc: 'DIF > 0.3',
      weakDowntrend: 'Weak Downtrend',
      weakDowntrendDesc: 'DIF < -0.3',
      parameters: 'Strategy Parameters',
      slopeThreshold: 'Slope Threshold: 0.3',
      difThreshold: 'DIF Weak Threshold: 0.3',
      defaultLeverage: 'Default Leverage: 5x',
      stopLoss: 'Stop Loss: -3%',
      takeProfit: 'Take Profit: 5%',
      samplingInterval: 'Sampling: 1 minute',
      riskManagement: 'Risk Management',
      noNewPositions: 'No new positions in stable trend',
      closeOpposite: 'Close position when trend reverses',
      advantages: 'Strategy Advantages',
      transparent: 'Fully transparent rules',
      fast: 'Fast response (no AI API)',
      zeroCost: 'Zero additional cost',
      predictable: 'Predictable trading logic',
    },
  },

  zh: {
    // Header
    title: 'ALPHA ARENA',
    nav: {
      live: '实时',
      leaderboard: '排行榜',
    },
    joinWaitlist: '加入候补名单',
    connected: '已连接',

    // Account Value
    totalAccountValue: '账户总价值',
    timeRanges: {
      all: '全部',
      '72h': '72小时',
      '24h': '24小时',
      '12h': '12小时',
      '5h': '5小时',
    },
    liveTracking: '实时账户价值追踪 - 每1分钟更新一次',

    // Tabs
    tabs: {
      completedTrades: '已完成交易',
      modelChat: '模型对话',
      positions: '持仓',
      readme: '说明文档',
      leadingModels: '领先模型',
    },

    // Completed Trades
    trades: {
      title: '最近交易',
      count: '笔交易',
      noTrades: '暂无已完成的交易',
      aiWillStart: 'AI 模型即将开始交易',
      headers: {
        time: '时间',
        symbol: '币种',
        side: '方向',
        quantity: '数量',
        price: '价格',
        total: '总额',
        pnl: '盈亏',
        model: '模型',
      },
      synced: '交易数据已从 Hyperliquid 同步 - 实时更新',
    },

    // Positions
    positions: {
      title: '持仓',
      activePositions: '个活跃持仓',
      noPositions: '暂无持仓',
      waitingForTrades: '等待 AI 模型开仓',
      totalPnl: '未实现盈亏总计',
      headers: {
        symbol: '币种',
        side: '方向',
        size: '仓位',
        entry: '开仓价',
        current: '当前价',
        leverage: '杠杆',
        pnl: '未实现盈亏',
        liqPrice: '强平价',
        model: '模型',
      },
      updates: '持仓通过 Hyperliquid WebSocket 实时更新',
    },

    // Model Chat
    chat: {
      greeting: '👋 你好！我是你的 AI 交易助手。你可以问我关于交易策略、近期表现或市场分析的问题。',
      thinking: 'AI 正在思考...',
      placeholder: '询问任何关于交易策略的问题...',
      send: '发送',
      suggested: '建议的问题：',
      questions: [
        '你目前的策略是什么？',
        '展示最近的交易记录',
        '你的风险管理方法是什么？',
        '分析 BTC 市场',
      ],
      footer: 'AI 回复由 Claude 提供支持 - 连接你的 API 密钥以启用',
    },

    // Leading Models
    models: {
      title: '表现最佳的模型',
      ranked: '按总回报率排名',
      active: '个活跃模型',
      totalRoi: '总回报率',
      roi24h: '24小时回报率',
      winRate: '胜率',
      trades: '交易次数',
      sharpe: '夏普比率',
      currentBalance: '当前余额',
      tracked: '模型表现实时追踪 - 数据来自 Hyperliquid',
    },

    // README
    readme: {
      title: '说明文档',
      content: {
        heading: '# Alpha Arena - AI 交易平台',
        description: '本平台展示了在 Hyperliquid DEX 上运行的自主 AI 交易代理。',
        features: '## 功能特性：',
        featureList: [
          '来自 Hyperliquid 的实时市场数据',
          '自主 AI 交易模型',
          '实时持仓追踪',
          '交易历史和分析',
          '模型性能排行榜',
        ],
        dataSources: '## 数据来源：',
        sourceList: [
          'Hyperliquid API（REST + WebSocket）',
          '实时价格推送',
          '链上交易执行',
        ],
        status: '状态：所有系统正常运行。AI 模型正在积极交易。',
      },
    },

    // Leaderboard
    leaderboard: {
      title: '模型排行榜',
      description: '即将推出 - 按表现排名的 AI 交易模型',
    },

    // Status
    status: {
      streaming: '状态：已连接到 HYPERLIQUID',
      poweredBy: '实时数据由 Hyperliquid API 提供',
    },

    // Common
    common: {
      loading: '加载中...',
      comingSoon: '即将推出...',
      buy: '买入',
      sell: '卖出',
      long: '做多',
      short: '做空',
      active: '活跃',
      paused: '暂停',
      filter: '筛选',
      allModels: '所有模型',
      equity: '权益',
      roi: '投资回报率',
      winRate: '胜率',
      trades: '交易次数',
      netPnl: '净盈亏',
      waitingForData: '等待数据...',
      price: '价格',
      quantity: '数量',
      notional: '名义价值',
      holdingTime: '持仓时间',
      showingLast: '显示最近',
      tradesText: '笔交易',
      loadingPositions: '加载持仓中...',
      loadingTrades: '加载交易中...',
      completedA: '完成了一笔',
      tradeOn: '交易，币种',
      view: '查看',
      availableCash: '可用资金',
      side: '方向',
      coin: '币种',
      leverage: '杠杆',
      exitPlan: '退出计划',
      totalUnrealizedPnl: '未实现盈亏总计',
    },

    // Control Panel
    control: {
      title: 'AI 交易机器人 - 多模型竞赛',
      competitionMode: '竞赛模式：DeepSeek-V3、豆包、通义千问和 MACD 策略将同时运行，独立交易，实时对比性能表现！',
      deepseekTitle: 'DeepSeek-V3',
      doubaoTitle: '豆包 (Doubao)',
      qwenTitle: '通义千问 (Qwen)',
      macdTitle: 'MACD 规则策略',
      apiKey: 'API 密钥',
      apiKeyRequired: 'API 密钥 *',
      modelEndpoint: '模型端点 ID（可选）',
      modelId: '模型 ID（可选）',
      getApiKeys: '从以下地址获取您的 API 密钥',
      volcengineConsole: '火山引擎 Ark 控制台',
      initialBalance: '初始余额 (USDT)',
      analysisInterval: '分析间隔（分钟）',
      intervalOptions: {
        fast: '1 分钟（快速）',
        recommended: '5 分钟（推荐）',
        conservative: '15 分钟（保守）',
        longTerm: '1 小时（长期）',
      },
      startBot: '启动所有交易机器人',
      starting: '启动中...',
      stopBot: '停止所有机器人',
      stopping: '停止中...',
      botsRunning: '多模型竞赛运行中',
      analysisCount: '分析次数 #',
      latest: '最新:',
      performanceComparison: '性能对比',
      errorDeepseekKey: '请输入 DeepSeek API 密钥',
      errorDoubaoKey: '请输入豆包 API 密钥',
      errorQwenKey: '请输入通义千问 API 密钥',
      pnlLabel: '盈亏:',
      equityLabel: '权益:',
      macdStrategy: 'MACD 规则策略',
      macdDescription: '完全自动化的规则交易，无需 AI',
      aiStrategy: 'AI 模型策略',
    },

    // Sidebar (old version, kept for compatibility)
    sidebar: {
      tabs: {
        completedTrades: '已完成交易',
        positions: '持仓',
        modelChat: '模型对话',
        readme: '说明文档',
      },
      readmeContent: {
        betterBenchmark: '更好的基准测试',
        description: 'Alpha Arena 是首个专为衡量 AI 交易能力而设计的基准测试。每个模型都获得 1,000 美元的真实资金，在真实市场中，使用相同的提示词和输入数据进行交易。',
        goal: 'Alpha Arena 的目标是让基准测试更接近真实世界，而市场正是完美的选择。市场是动态的、对抗性的、开放式的，且具有无尽的不可预测性。它们以静态基准测试无法做到的方式挑战 AI。',
        ultimate: '市场是智能的终极考验。',
        question: '那么，我们是否需要训练具有新架构的模型来进行投资，还是大语言模型就足够了？让我们拭目以待。',
        contestants: '参赛选手',
        rules: '竞赛规则',
        startingCapital: '初始资金',
        startingCapitalDesc: '每个模型获得 1,000 美元的真实资金',
        market: '市场',
        marketDesc: 'Hyperliquid 加密货币永续合约',
        objective: '目标',
        objectiveDesc: '最大化风险调整后收益',
        transparency: '透明度',
        transparencyDesc: '所有模型输出及其相应的交易和价格均公开',
        autonomy: '自主性',
        autonomyDesc: '每个 AI 必须独立产生 alpha、确定交易规模并管理风险',
      },
    },

    // Trading Log
    tradingLog: {
      title: '交易分析',
      clickToExpand: '点击展开查看详细过程',
      waitingForBot: '等待交易机器人启动...',
      startMessage: '启动后，这里将显示实时交易分析',
      noRecords: '没有符合条件的交易记录',
      tryOtherFilters: '尝试切换其他筛选条件',
      autoScroll: '自动滚动',
      pausedScroll: '已暂停',
      clearLogs: '清空日志',
      completeAnalysis: '完整分析流程',
      macdAnalysis: 'MACD 技术指标分析',
      extremumDetected: '极值点检测',
      openSignal: '开仓信号',
      closeSignal: '平仓信号',
      emergencyClose: '紧急平仓 - 信号预测',
      dataCollection: '数据收集阶段',
      macdStrategy: 'MACD 规则策略',
      aiStrategy: 'AI 模型策略',
      marketData: '市场数据更新',
      accountStatus: '账户状态',
      riskCheck: '风险检查',
      execution: '交易执行',
    },

    // Account Value
    accountValue: {
      totalValue: '账户总价值',
      waitingForData: '等待数据...',
    },

    // Price Ticker
    priceTicker: {
      loading: '加载中...',
    },

    // Page Buttons
    page: {
      models: '模型',
      close: '关闭',
      control: '控制面板',
    },

    // ETH Price & MACD
    ethPrice: {
      title: 'ETH 价格 & MACD',
      currentPrice: '当前价格',
      change24h: '24小时涨跌',
      open: '开盘',
      high: '最高',
      low: '最低',
      close: '收盘',
      priceBox: '价格箱图',
      macdTitle: 'MACD 指标',
      macdDif: 'DIF',
      macdDea: 'DEA',
      macdBar: 'MACD 柱',
      macdSignal: '信号',
      bullish: '看涨',
      bearish: '看跌',
      neutral: '中性',
      clickTip: '点击 DIF 曲线查看斜率详情',
      firstOrderSlope: '一阶斜率',
      secondOrderSlope: '二阶斜率',
      macdFirstOrderSlope: 'MACD 一阶斜率',
      macdSecondOrderSlope: 'MACD 二阶斜率',
      slopeDirection: '斜率方向',
      trendStrength: '趋势强度',
      slopeSignal: '斜率信号',
      accelerating: '加速',
      decelerating: '减速',
      stable: '稳定',
      strong: '强',
      moderate: '中等',
      weak: '弱',
      up: '上升',
      down: '下降',
      flat: '平稳',
      // BOLL带
      bollBands: 'BOLL带 (VWAP)',
      bollUpper: '上轨',
      bollMiddle: '中轨 (VWAP)',
      bollLower: '下轨',
      percentB: '%B指标',
      bandwidth: '带宽',
    },

    // MACD Strategy Rules
    macdRules: {
      title: 'MACD 规则交易策略',
      subtitle: '基于技术指标的自动化交易',
      strongUptrend: '强势上涨趋势',
      strongUptrendDesc: 'DIF 一阶斜率 > 0.3 且 二阶斜率 > 0',
      strongUptrendAction: '开多 / 持多 / 平空',
      strongDowntrend: '强势下跌趋势',
      strongDowntrendDesc: 'DIF 一阶斜率 < -0.3 且 二阶斜率 < 0',
      strongDowntrendAction: '开空 / 持空 / 平多',
      stableTrend: '稳定趋势',
      stableTrendDesc: 'DIF 一阶斜率在 -0.3 到 0.3 之间',
      stableTrendAction: '持仓观望，不开新仓',
      weakUptrend: '微弱上涨',
      weakUptrendDesc: 'DIF > 0.3',
      weakDowntrend: '微弱下跌',
      weakDowntrendDesc: 'DIF < -0.3',
      parameters: '策略参数',
      slopeThreshold: '斜率阈值：0.3',
      difThreshold: 'DIF 弱趋势阈值：0.3',
      defaultLeverage: '默认杠杆：5 倍',
      stopLoss: '止损：-3%',
      takeProfit: '止盈：5%',
      samplingInterval: '采样间隔：1 分钟',
      riskManagement: '风险管理',
      noNewPositions: '稳定趋势中不开新仓',
      closeOpposite: '趋势反转时平仓',
      advantages: '策略优势',
      transparent: '规则完全透明',
      fast: '快速响应（无需 AI API）',
      zeroCost: '零额外成本',
      predictable: '可预测的交易逻辑',
    },
  },
};

export function getTranslation(locale: Locale) {
  return translations[locale];
}
